export default {
  NORMAL: 'normal',
  ANONIMOUS: 'anonimous',
  NAME: 'name',
};
